import React, { useRef } from 'react';
import { DatalistBanner } from 'reactApp/ui/AdvBanners/DatalistBanner/DatalistBanner';

import { UploadProvocation } from '../UploadProvocation/UploadProvocation';
import { IProvocation } from '../UploadProvocation/UploadProvocation.types';

interface IProps {
    itemsCount: number;
}

export const ExtraBlocks = ({ itemsCount }: IProps) => {
    const provocationRef = useRef<IProvocation | null>(null);
    const isProvocationShown = Boolean(provocationRef?.current?.canShow());

    return (
        <>
            <UploadProvocation ref={provocationRef} />
            {!isProvocationShown && <DatalistBanner itemsCount={itemsCount} />}
        </>
    );
};
